export default __webpack_public_path__ + "static/media/overviewBgMobile@2x.e312eda9.png";